import {
  Component,
  AfterViewInit,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  TemplateRef,
  Inject,
  Renderer2,
  NgZone,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MapaServiceService, ServiceFilterStartEndData } from 'src/app/services/mapa/mapa-service.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TuiAlertService } from '@taiga-ui/core';
import { HistoryServicesService } from 'src/app/services/history-services/history-services.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var MarkerClusterer: any;
declare var moment: any;
import { TranslateService } from '@ngx-translate/core';
import { OrderData } from 'src/app/models/service/service.model';
import { DriverDetails } from 'src/app/models/driver/driver.model';
import {
  DriverFilterType,
  ServiceFilterData,
} from 'src/app/models/map-drivers/map-drivers.model';
import { MapaDataUnifierService } from 'src/app/services/mapa/mapa-data-unifier.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.css'],
})
export class MapaComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('gmapContainer', { static: false }) gmap: ElementRef | undefined;
  map: any = google.maps.Map;
  lat = 40.4165;
  lng = -3.70256;
  zoom_level = 6;
  coordinates = new google.maps.LatLng(this.lat, this.lng);
  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 6,
    disableDefaultUI: true,
  };
  open = false;
  selectedItemFilter = 'services';
  isPoolMode = false;

  private get filtersStorageKey(): string {
    return this.isPoolMode ? 'mapa_pool_filters' : 'mapa_service_filters';
  }
  private destroy$ = new Subject<void>();
  private mapEventListeners: google.maps.MapsEventListener[] = [];
  private abortController: AbortController | null = null;

  active_inside_service_div = 'closets';
  mapInitializer() {
    this.map = new google.maps.Map(this.gmap?.nativeElement, this.mapOptions);
  }

  changeInsideServiceactive(type: any) {
    this.active_inside_service_div = type;
  }

  modalRef?: BsModalRef;
  constructor(
    @Inject(TuiAlertService) private readonly alerts: TuiAlertService,
    private fb: FormBuilder,
    private ms: MapaServiceService,
    private modalService: BsModalService,
    private renderer: Renderer2,
    public hs: HistoryServicesService,
    private ngZone: NgZone,
    private translate: TranslateService,
    private mapaDataUnifier: MapaDataUnifierService,
    private route: ActivatedRoute
  ) {}

  filterForm = this.fb.group({
    zoneFilter: '',
    mapfilter: [''],
    dateFilter: '',
  });

  filterDriverServiceForm = this.fb.group({
    driverservicefilter: '',
  });

  elements_services: any = [];
  filtered_services: any = [];

  elements_drivers: any = [];
  filtered_drivers: any = [];

  leftDivStyles = {
    x: 440,
  };
  expandDivLeft = true;
  show_left_div = true;
  zones: any;
  service_data: any;
  count_drivers_closets = 0;

  active_detail_service: any;
  active_driver: any;

  drivers_for_service: any = [];
  selectedZone: any = '#';

  PointsMarkers: any = [];
  userLocationMarker: any = null;
  dateFilter: any;
  show_assign_services = 0;
  active_desasign_driver: any;

  VehicleChassisType = [
    {
      value: 1,
      name: 'SEDAN',
      real_name: 'Turismo',
    },
    {
      value: 2,
      name: 'MINIVAN',
      real_name: 'Monovolumen',
    },
    {
      value: 3,
      name: 'ATV',
      real_name: 'Todoterreno',
    },
    {
      value: 4,
      name: 'LIGHT_VAN',
      real_name: 'Furgoneta ligera',
    },
    {
      value: 5,
      name: 'VAN',
      real_name: 'Furgoneta',
    },
    {
      value: 6,
      name: 'BOX_TRUCK',
      real_name: 'Furgón',
    },
    {
      value: 20,
      name: 'SCOOTER',
      real_name: 'Moto (hasta 125cc)',
    },
    {
      value: 21,
      name: 'MOTORBIKE',
      real_name: 'Moto +125cc',
    },
  ];

  markerCluster: any;
  directionsRenderer: any;
  provider_address: any = '';

  getTypeChassisByType(vehicleName: any) {
    const selectedVehicle = this.VehicleChassisType.find(
      (type: any) => type.name === vehicleName
    );
    return selectedVehicle?.real_name;
  }

  ngOnInit() {
    this.isPoolMode = this.route.snapshot.data?.['mode'] === 'pool';

    const today = new Date().toISOString().split('T')[0];
    this.filterForm.get('dateFilter')?.setValue(today, { emitEvent: false });

    let divmap = document.getElementsByClassName('custom-container');
    if (divmap.length > 0) {
      let mapdiv = divmap[0] as HTMLElement;
      mapdiv.style.padding = '0px';
    }

    this.ms.getZones()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (zones: any) => {
          this.zones = zones.zones;
          this.restoreFilters();
        },
        error: (error: any) => {
          this.alerts
            .open(
              this.translate.instant('Unable to load zones. Please refresh the page.'),
              {
                label: this.translate.instant('common.actions.error'),
                status: 'error',
                autoClose: true,
              }
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe();
        }
      });

    this.setupVisibilityChangeListener();
  }

  private setupVisibilityChangeListener(): void {
    const visibilityHandler = () => {
      if (!document.hidden && this.map) {
        setTimeout(() => {
          google.maps.event.trigger(this.map, 'resize');
        }, 500);
      }
    };
    document.addEventListener('visibilitychange', visibilityHandler);
  }



  div_loder = document.getElementById('loader');
  showLoader() {
    if (this.div_loder) {
      this.renderer.setStyle(this.div_loder, 'display', 'flex');
    }
  }

  hideLoader() {
    if (this.div_loder) {
      this.renderer.setStyle(this.div_loder, 'display', 'none');
    }

    setTimeout(() => {
      const closeDiv = document.querySelector('.t-close');
      if (closeDiv) {
        (closeDiv as HTMLElement).click();
      }
    }, 5000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    let divmap = document.getElementsByClassName('custom-container');
    if (divmap.length > 0) {
      let mapdiv = divmap[0] as HTMLElement;
      mapdiv.style.padding = '30px';
    }
    if (this.userLocationMarker) {
      this.userLocationMarker.setMap(null);
    }
    this.clearFilters();
  }

  getRandomOffset() {
    return (Math.random() - 0.9) / 10; // Ajusta este valor según sea necesario
  }

  rolesGeneral: any[] = [
    { name: this.translate.instant('personal.role_not_specified'), role: 'NOT_SPECIFIED' },
    { name: this.translate.instant('personal.role_regular'), role: 'REGULAR' },
    { name: this.translate.instant('personal.role_long_distance'), role: 'LONG_DISTANCE' },
    { name: this.translate.instant('personal.role_broom_car'), role: 'BROOM_CAR' },
    { name: this.translate.instant('personal.role_mobile_washer'), role: 'MOBILE_WASHER' },
    { name: this.translate.instant('personal.role_implant_washer'), role: 'IMPLANT_WASHER' },
    { name: this.translate.instant('personal.role_implant_office'), role: 'IMPLANT_OFFICE' },
    { name: this.translate.instant('personal.role_mobile_workshop'), role: 'MOBILE_WORKSHOP'},
    { name: this.translate.instant('personal.role_dispatch_vehicle'), role: 'DISPATCH_CAR'},
  ];

  private isServiceActiveStatus(service: any): boolean {
    return service.orderStatus !== 'FINISHED' &&
           service.orderStatus !== 'CANCELLED_BY_CAFLER' &&
           service.orderStatus !== 'CANCELLED_BY_CLIENT' &&
           service.orderStatus !== 'FAILED';
  }

  private clearAllMapElements(): void {
    if (this.directionsRenderer) {
      this.directionsRenderer.setDirections({ routes: [] });
      this.directionsRenderer.setMap(null);
    }
    this.directionsRenderers.forEach((renderer) => {
      renderer.setMap(null);
    });
    this.directionsRenderers = [];
    this.customMarkers.forEach((marker) => {
      marker.setMap(null);
    });
    this.customMarkers = [];
    this.clearMarkers();
  }

  ngAfterViewInit() {
    this.mapInitializer();
    
    this.filterForm.get('dateFilter')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.saveFilters();
        this.loadData();
      });
  }

  loadData() {
    const isPool = this.route.snapshot.data?.['mode'] === 'pool';
    if (isPool) {
      this.loadPoolData();
    } else {
      this.loadServiceManagerData();
    }
  }

  onZoneChange(): void {
    this.saveFilters();
    this.loadData();
  }

  private async loadPoolData() {
    const zoneFilter = this.filterForm.value.zoneFilter;
    if (!zoneFilter) return;

    let dateFilter = this.filterForm.value.dateFilter as any;
    if (!dateFilter) {
      dateFilter = new Date().toISOString().split('T')[0];
      this.filterForm.get('dateFilter')?.setValue(dateFilter, { emitEvent: false });
    }

    this.resetFilteredData();
    this.showLoader();

    const serviceData: ServiceFilterStartEndData = {
      StartDate: Array.isArray(dateFilter) ? dateFilter[0] : dateFilter,
      EndDate: Array.isArray(dateFilter) ? dateFilter[1] : dateFilter,
      ZoneGuid: zoneFilter,
    };

    this.elements_services = [];
    this.filtered_services = [];
    this.elements_drivers = [];
    this.filtered_drivers = [];
    this.clearAllMapElements();
    this.PointsMarkers = [];

    try {
      const rawServices = await this.mapaDataUnifier.loadPoolServices(serviceData);
      this.elements_services = this.mapaDataUnifier.normalizePoolServices(
        rawServices,
        this.translate.currentLang
      );
    } catch (error) {
      console.error('Error al cargar servicios de pool:', error);
    }

    this.PointsMarkers = this.mapaDataUnifier.buildPoolMapPoints(this.elements_services);
    this.filtered_services = [...this.elements_services];

    try {
      this.elements_drivers = await this.mapaDataUnifier.loadExternalDrivers(
        this.elements_services,
        this.PointsMarkers
      );
      this.filtered_drivers = this.elements_drivers.filter(
        (d: any) => d?.general_info?.isActive
      );
    } catch (error) {
      console.error('Error al cargar conductores autónomos:', error);
    }

    try {
      this.drawMapPoints();
    } catch (error) {
      console.error('Error al dibujar puntos del mapa:', error);
    } finally {
      this.hideLoader();
    }

    if (this.filtered_services.length === 0 && this.filtered_drivers.length > 0) {
      this.changeSelectedItemFilter('drivers');
    } else if (this.filtered_drivers.length === 0 && this.filtered_services.length > 0) {
      this.changeSelectedItemFilter('services');
    }
  }

  private loadServiceManagerData() {
    this.resetFilteredData();

    if (this.filterForm.value.dateFilter && this.filterForm.value.zoneFilter) {
      this.showLoader();
      var date_send = Math.floor(
        new Date(this.filterForm.value.dateFilter).getTime() / 1000
      );
      const serviceData: ServiceFilterData = {
        date: { seconds: date_send },
        zoneId: this.filterForm.value.zoneFilter,
      };

      this.elements_services = [];
      this.filtered_services = [];
      this.elements_drivers = [];
      this.filtered_drivers = [];

      this.clearAllMapElements();
      this.PointsMarkers = [];

      this.ms.getServices(serviceData).subscribe({
        next: (services: any) => {
          services.forEach((obj: any, index: any) => {
            obj.unassignedServices.forEach((obj2: any, index2: any) => {
              this.elements_services.push(
                this.mapaDataUnifier.normalizeServiceManagerService(obj2)
              );
            });

            obj.activeDrivers.forEach((obj: any, index: any) => {
              this.elements_drivers.push(obj);
            });
          });

        this.PointsMarkers = this.mapaDataUnifier.buildServiceManagerMapPoints(
          this.elements_services
        );
        this.filtered_services = [...this.elements_services];

        let driverPromises = this.elements_drivers.map(
          (obj: any, index: any) => {
            return this.ms
              .getDriver(obj.driverId)
              .toPromise()
              .then((data: any) => {
                const general_info = data?.drivers?.[0];
                if (!general_info) return;
                obj.general_info = general_info;

                // No mostramos en el mapa a los conductores inactivos.
                if (!general_info.isActive) return;

                if (obj.general_info?.lastLocation) {
                  let data = {
                    type: 'driver',
                    obj: obj.general_info.lastLocation,
                    data: general_info,
                  };

                  this.PointsMarkers.push(data);
                }
                if (obj.assignedServices.length > 0) {
                  if (general_info && general_info.isActive) {
                    obj.assignedServices
                      .filter((x: any) => this.isServiceActiveStatus(x))
                      .forEach((service: any) => {
                        if (service.pickupPoint) {
                          let data = {
                            type: 'pickup',
                            obj: service.pickupPoint,
                            data: service,
                          };
                          this.PointsMarkers.push(data);
                        }
                        if (service.destinationPoint) {
                          let data2 = {
                            type: 'dest',
                            obj: service.destinationPoint,
                            data: service,
                          };
                          this.PointsMarkers.push(data2);
                        }
                      });

                    obj.assignedServices = obj.assignedServices
                      .filter((x: any) => this.isServiceActiveStatus(x))
                      .sort((a: any, b: any) => {
                        let textDateStartA = a.pickupDate.time.split(':');
                        let textDateStartB = b.pickupDate.time.split(':');

                        const hourA = textDateStartA[0] + ':' + textDateStartA[1];
                        const hourB = textDateStartB[0] + ':' + textDateStartB[1];

                        if (hourA < hourB) return -1;
                        if (hourA > hourB) return 1;
                        return 0;
                      });
                  }
                }
              });
          }
        );

        Promise.allSettled(driverPromises)
          .then((results) => {
            const rejectedCount = results.filter(
              (result) => result.status === 'rejected'
            ).length;
            if (rejectedCount > 0 && !environment.production) {
              console.warn(
                `Fallaron ${rejectedCount} llamadas de detalle de conductor, se continúa con los datos disponibles.`
              );
            }

            this.filtered_drivers = [
              ...this.elements_drivers.filter(
                (x: any) =>
                  x.general_info !== undefined && x.general_info.isActive === true
              ),
            ];

            this.drawMapPoints();

            if (this.filtered_services.length === 0 && this.filtered_drivers.length === 0) {
              this.alerts
                .open(
                  this.translate.instant('MAP.NO_RESULTS'),
                  {
                    label: this.translate.instant('MAP.NO_RESULTS_TITLE'),
                    status: 'info',
                    autoClose: 5000,
                  }
                )
                .subscribe();
            } else if (
              this.filtered_services.length === 0 &&
              this.filtered_drivers.length > 0
            ) {
              this.changeSelectedItemFilter('drivers');
            }
          })
          .finally(() => {
            this.hideLoader();
          });
      },
      error: (error: any) => {
        this.hideLoader();
        this.alerts
          .open(
            this.translate.instant('MAP.LOAD_ERROR'),
            {
              label: this.translate.instant('common.actions.error'),
              status: 'error',
              autoClose: true,
            }
          )
          .subscribe();
      }
      });
    }
  }

  resetFilteredData(): void {
    this.filterForm.get('mapfilter')?.setValue('');
    this.filtered_services = [...this.elements_services];
    this.filtered_drivers = [...this.elements_drivers].filter(
      (item: any) => item?.fullName && item?.isActive === true
    );
  }

  filterData(event: Event | string): void {
    const query =
      typeof event == 'string'
        ? event.toLowerCase()
        : (event.target as HTMLInputElement).value.toLowerCase();

    if (this.selectedItemFilter == 'services') {
      this.filtered_services = [...this.elements_services].filter(
        (item: any) =>
          item?.licensePlate?.toLowerCase().includes(query) ||
          item?.productName?.toLowerCase().includes(query) ||
          item?.startUbication?.address.toLowerCase().includes(query)
      );
    }

    if (this.selectedItemFilter == 'drivers') {
      this.filtered_drivers = [...this.elements_drivers].filter(
        (item: any) =>
          (item?.general_info?.fullName?.toLowerCase().includes(query) ||
            item?.general_info?.contactPhoneNumber
              .toLowerCase()
              .includes(query)) &&
          item?.general_info?.isActive === true
      );
    }
  }

  filterDataDriverService(event: Event): void {
    const query = (event.target as HTMLInputElement).value.toLowerCase();

    if (this.active_inside_service_div == 'closets') {
      this.drivers_for_service = this.elements_drivers_services.filter(
        (item: any) => item.driverName.toLowerCase().includes(query)
      );
      this.count_drivers_closets = this.drivers_for_service?.length;
    }

    if (this.active_inside_service_div == 'actives') {
      this.filtered_drivers = this.elements_drivers.filter((item: any) =>
        item.general_info?.fullName.toLowerCase().includes(query)
      );
    }
  }

  getInitial(nombre: any) {
    if (!nombre) return '';
    const partes = String(nombre).trim().split(/\s+/).filter((p: string) => p);
    const primera = partes[0]?.[0]?.toUpperCase() ?? '';
    const segunda = partes[1]?.[0]?.toUpperCase() ?? '';
    return `
            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" fill="#59F89C"/>
                <text x="50%" y="53%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="17" font-family="Arial">${primera + segunda}</text>
            </svg>`;
  }

  markers: google.maps.Marker[] = [];
  isInfoWindowOpen = false;
  currentCluster: any = null;
  hoverTimeout: any = null;
  isMouseOverCluster: any = false;
  customMarkers: google.maps.Marker[] = [];

  async drawRoutes(service: any) {
    this.ngZone.run(() => {
      this.clearAllMapElements();
    });

    const directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
    });
    let waypts: google.maps.DirectionsWaypoint[] = [];
    let start = {};
    let end = {};

    if (service.nodes) {
      if (
        !service.nodes.find(
          (nod: any) => nod.nodeVerticalType === 'INTERNAL_RETURN'
        )
      ) {
        if (service.destinationPoint) {
          if (
            service.destinationPoint.Latitude !=
            service.destinationPoint.Longitude
          ) {
            end = {
              lat: service.destinationPoint.Latitude,
              lng: service.destinationPoint.Longitude,
            };
          }
        }
      }
      if (
        !service.nodes.find(
          (nod: any) => nod.nodeVerticalType === 'INTERNAL_PICKUP'
        )
      ) {
        if (service.pickupPoint) {
          if (service.pickupPoint.Latitude != service.pickupPoint.Longitude) {
            start = {
              lat: service.pickupPoint.Latitude,
              lng: service.pickupPoint.Longitude,
            };
          }
        }
      }
      service.nodes.forEach((obj: any, index: any) => {
        if (obj.nodeVerticalType == 'INTERNAL_PICKUP') {
          if (obj.location.Latitude != obj.location.Longitude) {
            start = {
              lat: obj.location.Latitude,
              lng: obj.location.Longitude,
            };
          }
        }

        if (obj.nodeVerticalType == 'INTERNAL_RETURN') {
          if (obj.location.Latitude != obj.location.Longitude) {
            end = {
              lat: obj.location.Latitude,
              lng: obj.location.Longitude,
            };
          }
        }

        if (
          obj.nodeVerticalType != 'INTERNAL_RETURN' &&
          obj.nodeVerticalType != 'INTERNAL_PICKUP'
        ) {
          if (obj.location) {
            if (obj.location.Latitude != obj.location.Longitude) {
              let wlo = new google.maps.LatLng(
                obj.location.Latitude,
                obj.location.Longitude
              );
              waypts.push({
                location: wlo,
                stopover: true,
              });
            }
          }
        }
      });

      this.directionsRenderer.setMap(this.map);
      if (waypts.length > 0) {
        directionsService.route(
          {
            origin: start,
            destination: end,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response) => {
            this.directionsRenderer.setDirections(response);
            this.directionsRenderers.push(this.directionsRenderer);
            this.addCustomMarkers(response);
          }
        );
      } else {
        directionsService.route(
          {
            origin: start,
            destination: end,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response) => {
            this.directionsRenderer.setDirections(response);
            this.directionsRenderers.push(this.directionsRenderer);
            this.addCustomMarkers(response);
          }
        );
      }
    }
  }

  mt: any;
  drivers_markers: any = [];
  drawMapPoints() {
    this.PointsMarkers.forEach((obj: any, index: any) => {
      const offset = 0.00005;
      var latOffset = this.getRandomOffset();
      var lngOffset = this.getRandomOffset();
      var latOffset2 = this.getRandomOffset();
      var lngOffset2 = this.getRandomOffset();

      if (obj.type == 'pickup') {
        if (obj.data) {
          var dataService = JSON.stringify(obj.data);
        } else {
          var dataService = '{}';
        }

        const pickupTimeStr = obj.data.pickupDate?.time ?? obj.data.serviceHour ?? '';
        const pickupTimeParts = pickupTimeStr.split(':');
        const pickupDateFormated = pickupTimeParts.length >= 2 ? `${pickupTimeParts[0]}:${pickupTimeParts[1]}` : '';
        const pickupLat = obj.obj.Latitude ?? obj.obj.latitude;
        const pickupLng = obj.obj.Longitude ?? obj.obj.longitude;
        const pickupAddress = obj.data.pickupAddress ?? obj.obj?.address ?? '';
        const pickupProductName = obj.data.mainProductName ?? obj.data.productName ?? '';
        const pickupChassis = obj.data.chassis ?? obj.data.vehicleType;

        let mrkc = new google.maps.LatLng(pickupLat, pickupLng);
        let mrk = new google.maps.Marker({
          position: mrkc,
          title: `
                          <span style="cursor:pointer" class="span_service_map"
                                data-service='${dataService.replace(
                                  /'/g,
                                  '&apos;'
                                )}'>
                            <img src="/assets/img/icon_service.png"/>
                            ${pickupAddress},
                            <b>${this.hs.translate(pickupProductName)} - ${
            obj.data.licensePlate
          } ${this.getTypeChassisByType(pickupChassis)},</b>
                            ${pickupDateFormated}
                          </span>
                        `,
          icon: '/assets/img/icon_service.png',
        });
        obj.marker = mrk;
      }

      if (obj.type == 'dest') {
        if (obj.data) {
          var dataService = JSON.stringify(obj.data);
        } else {
          var dataService = '{}'; // Un valor JSON válido por defecto
        }

        const destTimeStr = obj.data.pickupDate?.time ?? obj.data.serviceHour ?? '';
        const destTimeParts = destTimeStr.split(':');
        const destDateFormated = destTimeParts.length >= 2 ? `${destTimeParts[0]}:${destTimeParts[1]}` : '';
        const destLat = obj.obj.Latitude ?? obj.obj.latitude;
        const destLng = obj.obj.Longitude ?? obj.obj.longitude;
        const destAddress = obj.data.pickupAddress ?? obj.obj?.address ?? '';
        const destProductName = obj.data.mainProductName ?? obj.data.productName ?? '';
        const destChassis = obj.data.chassis ?? obj.data.vehicleType;

        let mrkc2 = new google.maps.LatLng(destLat, destLng);
        let mrk2 = new google.maps.Marker({
          position: mrkc2,
          title: `
                          <span style="cursor:pointer" class="span_service_map"
                                data-service='${dataService.replace(
                                  /'/g,
                                  '&apos;'
                                )}'>
                            <img src="/assets/img/icon_service2.png"/>
                            ${destAddress},
                            <b>${this.hs.translate(destProductName)} - ${
            obj.data.licensePlate
          } ${this.getTypeChassisByType(destChassis)},</b>
                            ${destDateFormated}
                          </span>
                        `,
          icon: '/assets/img/icon_service2.png',
        });
        obj.marker = mrk2;
      }

      if (obj.type == 'driver') {
        if (obj.data) {
          var dataDriver = JSON.stringify(obj.data);
          let mrkc3 = new google.maps.LatLng(
            obj.obj.Latitude,
            obj.obj.Longitude
          );
          let mrk3 = new google.maps.Marker({
            position: mrkc3,
            title:
              this.getInitial(obj.data.fullName) +
              `
                              <span style="cursor:pointer" class="span_driver_map"
                                    data-driver='${dataDriver.replace(
                                      /'/g,
                                      '&apos;'
                                    )}'>
                                ${obj.data.fullName}
                              </span>
                            `,
            icon: {
              url:
                'data:image/svg+xml;charset=UTF-8,' +
                encodeURIComponent(this.getInitial(obj.data.fullName)),
              scaledSize: new google.maps.Size(30, 30),
            },
          });

          mrk3.addListener('click', () => {
            this.onDriverMarkerClick(obj.data, obj.obj); // Llamar a tu función pasando los datos del conductor
          });

          obj.marker = mrk3;
          mrk3.addListener('mouseover', () => {
            // Guardar el title
            const originalTitleDriver = mrk3.getTitle();
            this.mt = originalTitleDriver;

            var spdriver = mrk3.getTitle();
            const regex = /data-driver='(.*?)'/;

            // Ejecutar la expresión regular en el texto
            const matchdriver = regex.exec(spdriver!);

            if (matchdriver && matchdriver[1]) {
              const dataDriverJson = JSON.parse(matchdriver[1]);
              mrk3.setTitle(dataDriverJson.fullName);
            } else {
             
              mrk3.setTitle('Titulo');
            }
          });

          // Evento para cerrar el InfoWindow
          mrk3.addListener('mouseout', () => {
            mrk3.setTitle(this.mt);
          });
          mrk3.setMap(this.map);
          this.drivers_markers.push(mrk3);
        }
      }
    });

    const map = this.map;
    const markers = this.PointsMarkers.filter(
      (item: any) => item.type != 'driver'
    ).map((position: any, i: any) => {
      const marker = position.marker;
      marker.addListener('mouseover', () => {
        // Guardar el title
        const originalTitle = marker.getTitle();
        this.mt = originalTitle;

        var sp = marker.getTitle();
        const regex = /data-service='(.*?)'/;

        // Ejecutar la expresión regular en el texto
        const match = regex.exec(sp);

        if (match && match[1]) {
          const dataServiceJson = JSON.parse(match[1]);
          if (position.type == 'pickup') {
            marker.setTitle(dataServiceJson.pickupAddress);
          } else {
            marker.setTitle(dataServiceJson.destinationAddress);
          }
        } else {
          marker.setTitle('Titulo');
        }
      });

      // Evento para cerrar el InfoWindow
      marker.addListener('mouseout', () => {
        marker.setTitle(this.mt);
      });
      return marker;
    });

    const markerCluster2 = new MarkerClusterer(map, markers, {
      styles: [
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-1',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-2',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-3',
        },
      ],
      clusterClass: 'custom-clustericon',
      zoomOnClick: false,
    });
    this.markerCluster = markerCluster2;
    const infoWindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, 0),
    });

    google.maps.event.addListener(markerCluster2, 'click', (cluster) => {
      const markers = cluster.getMarkers();
      let content =
        '\
                <table class="table table-bordered" style="width:700px">\
                    <thead>\
                    </thead>\
                    <tbody>';
      markers.forEach((marker: any) => {
        if (marker.getTitle() != '') {
          content += `<tr><td>${marker.getTitle()}</td><tr>`;
        }
      });
      content += '</tbody></table>';

      infoWindow.setContent(content);
      infoWindow.setPosition(cluster.getCenter());
      infoWindow.open(map);

      setTimeout(() => {
        var elementos = document.querySelectorAll('.span_service_map');
        elementos.forEach((elemento: any) => {
          elemento.addEventListener('click', (event: any) => {
            var dataService = elemento.getAttribute('data-service');
            try {
              var parsedData = JSON.parse(dataService);
              if (parsedData.driverId === '') {
                this.setActiveService(parsedData);
                infoWindow.close();
              } else {
                let driver = this.filtered_drivers.find(
                  (driver: any) => driver.driverId === parsedData.driverId
                );
                if (driver) {
                  this.setActiveService(parsedData, driver);
                  infoWindow.close();
                }
              }
            } catch (error) {
              console.error('Error al parsear data-service:', error);
            }
          });
        });

        var elementosdrivers = document.querySelectorAll('.span_driver_map');
        elementosdrivers.forEach((elemento: any) => {
          elemento.addEventListener('click', (event: any) => {
            var dataService = elemento.getAttribute('data-driver');
            try {
              var parsedData = JSON.parse(dataService);
            } catch (error) {
              console.error('Error al parsear data-driver:', error);
            }
          });
        });
      }, 500);
    });

    // Auto-ajustar zoom para mostrar todos los marcadores
    this.fitMapBounds();
  }

  fitMapBounds() {
    if (!this.map || this.PointsMarkers.length === 0) {
      return;
    }

    const bounds = new google.maps.LatLngBounds();
    let hasValidMarkers = false;

    this.PointsMarkers.forEach((point: any) => {
      if (point.obj && point.obj.Latitude && point.obj.Longitude) {
        bounds.extend(
          new google.maps.LatLng(point.obj.Latitude, point.obj.Longitude)
        );
        hasValidMarkers = true;
      }
    });

    if (hasValidMarkers) {
      this.map.fitBounds(bounds);
      
      const listener = google.maps.event.addListener(this.map, 'idle', () => {
        if (this.map.getZoom() > 15) {
          this.map.setZoom(15);
        }
        google.maps.event.removeListener(listener);
      });
    }
  }

  async focusDriverMap(driver: any, clearMarkers?: boolean) {
    if (driver?.general_info?.lastLocation) {
      let lastLocation = driver.general_info.lastLocation;
      let service = this.elements_services.find(
        (service: OrderData) => service.driverGuid === driver.driverId
      );

      this.centerMapOnLocation(
        lastLocation.Latitude,
        lastLocation.Longitude,
        driver.fullName,
        driver,
        clearMarkers
      );
    } else {
      this.alerts
        .open('El conductor no tiene una ubicación válida', {
          label: 'Sin ubicación',
          status: 'error',
          autoClose: 3000,
        })
        .subscribe();
    }
  }

  centerMapOnLocation(
    latitude: number,
    longitude: number,
    title?: string,
    driver?: any,
    clearMarkers?: boolean
  ): void {
    this.ngZone.run(() => {
      if (clearMarkers) {
        this.clearMarkers();
      }

      const newCoordinates = new google.maps.LatLng(latitude, longitude);
      if (!driver?.general_info?.lastLocation) {
        return;
      }
      
      let data = {
        type: 'driver',
        obj: driver.general_info.lastLocation,
        gi: driver.general_info,
      };
      this.PointsMarkers.push(data);
      this.drawMapPoints();
      
      setTimeout(() => {
        this.map.setCenter(newCoordinates);
        this.map.setZoom(17);
      }, 100);
    });
  }

  onDriverMarkerClick(driverGi: any, driverLocation: any): void {
    if (!this.show_left_div) {
      this.backToMap();
    }
    this.changeSelectedItemFilter('drivers');
    this.filterData(driverGi.fullName);
    this.filterForm.get('mapfilter')?.setValue(driverGi.fullName);

    this.map.setCenter(
      new google.maps.LatLng(
        driverLocation?.Latitude,
        driverLocation?.Longitude
      )
    );
    this.map.setZoom(15);
  }

  hideLeftDiv() {
    this.expandDivLeft = false;
    this.leftDivStyles.x = 155;
  }

  backToMap() {
    this.show_left_div = true;
    this.active_detail_service = null;
    this.drivers_for_service = [];
    this.selectedItemFilter = 'services';

    if (this.selectedItemFilter == 'services') {
      this.ngZone.run(() => {
        this.clearAllMapElements();
        this.drawMapPoints();
      });
    }
  }

  clients_list: any = [];
  client_info: any;
  correct_hour: any;
  elements_drivers_services: any = [];
  setActiveService(service: OrderData, driver?: any) {
    let data = {
      orderHash: service.orderHash,
      filterType: DriverFilterType.Proximity,
    };
    this.ngZone.run(() => {
      this.active_detail_service = service;

      let textDateStart = this.active_detail_service.pickupDate.time.split(':');
      this.active_detail_service.FormatedHour =
        textDateStart[0] + ':' + textDateStart[1];

      if (driver) {
        this.active_desasign_driver = driver;
      } else {
        this.active_desasign_driver = false;
      }
      this.show_left_div = false;
      this.type_driver_start = 'service';
    });
    this.showLoader();
    this.drawRoutes(service);

    this.hs.getServiceDetail(service.orderHash).subscribe((res: any) => {
      if (res.serviceDates.serviceAssignedPickupDate !== undefined) {
        let textDateStart2 =
          res.serviceDates.serviceAssignedPickupDate.time.split(':');
        this.correct_hour = textDateStart2[0] + ':' + textDateStart2[1];
      }
      this.ngZone.run(() => {
        this.provider_address = res.routeNodes.find(
          (item: any) =>
            item.mainProductVertical === 'TECHNICAL_INSPECTION' ||
            item.mainProductVertical === 'TRANSFER' ||
            item.mainProductVertical === 'MECHANICAL_INSPECTION' ||
            item.mainProductVertical === 'VEHICLE_WASH' ||
            item.mainProductVertical === 'REFUELING' ||
            item.mainProductVertical === 'PRE_TECHNICAL_INSPECTION' ||
            item.mainProductVertical === 'LONG_DISTANCE_TRANSFER' ||
            item.mainProductVertical === 'VEHICLE_INSURANCE' ||
            item.mainProductVertical === 'ACCESSORY' ||
            item.mainProductVertical === 'VALET' ||
            item.mainProductVertical === 'TYRES' ||
            item.mainProductVertical === 'FORMALITIES' ||
            item.mainProductVertical === 'PARKING' ||
            item.mainProductVertical === 'REPLACEMENT_VEHICLE' ||
            item.mainProductVertical === 'TOW_TRUCK' ||
            item.mainProductVertical === 'WHATEVER_YOU_WANT'
        )?.startAddress;
      });
      let service_in = res;
      this.hs.getClients().subscribe((res: any) => {
        this.clients_list = res.businessUserData;

        this.client_info = this.clients_list.find(
          (item: any) => item.userId == service_in.clientId
        );
      });
    });
    this.ms.getMapDrivers(data).subscribe((data: any) => {
      data.forEach((obj: any, index: any) => {
        obj.driversForService.forEach((obj: any, index: any) => {
          this.elements_drivers_services.push(obj);
        });
      });

      this.drivers_for_service = [...this.elements_drivers_services];
      this.drivers_for_service.sort(
        (a: any, b: any) => a.distanceToService - b.distanceToService
      );
      this.count_drivers_closets = this.drivers_for_service?.length;
      this.hideLoader();
    });

    if (driver?.general_info?.lastLocation) {
      this.clearMarkers();
      this.PointsMarkers = this.PointsMarkers.filter((pointer: any) => {
        return pointer.type != 'driver';
      });
      let data = {
        type: 'driver',
        obj: driver?.general_info?.lastLocation,
        gi: driver?.general_info,
      };
      this.PointsMarkers.push(data);

      this.drawMapPoints();
    }
  }

  openModalAssignDriver(
    templateModalLAssignDriver: TemplateRef<void>,
    driver: any
  ) {
    this.active_driver = driver;
    this.modalRef = this.modalService.show(
      templateModalLAssignDriver,
      Object.assign(
        {
          ignoreBackdropClick: false,
        },
        { class: 'gray modal-md mt_10p' }
      )
    );
  }

  openModalDesAssignDriver(
    templateModalDesAssignDriver: TemplateRef<void>,
    driver: any
  ) {
    this.active_driver = driver;
    this.active_desasign_driver = driver;
    this.modalRef = this.modalService.show(
      templateModalDesAssignDriver,
      Object.assign(
        {
          ignoreBackdropClick: false,
        },
        { class: 'gray modal-md mt_10p', id: 'mt_10p2' }
      )
    );
  }

  hideLoaderModal(search: any) {
    const div = document.querySelector('.' + search) as HTMLElement;
    if (div) {
      div.style.display = 'none'; // Agrega display: flex al div
    }
  }

  showLoaderModal(search: any) {
    const div = document.querySelector('.' + search) as HTMLElement;
    if (div) {
      div.style.display = 'flex'; // Agrega display: flex al div
    }
  }

  showErrorMsj() {
    setTimeout(() => {
      const sourceElement = document.querySelector('tui-alert');
      const targetElement = document.getElementById('loader');
      if (sourceElement && targetElement) {
        const clonedNode = sourceElement.cloneNode(true);
        targetElement.appendChild(sourceElement);
      }
    }, 300);
  }

  confirmAssign() {
    let data = {
      driverId: this.active_driver.driverId,
      orderHash: this.active_detail_service.orderHash,
      isSweeperAssignation: false,
      nodeId: this.active_detail_service.nodeId,
    };
    this.showLoaderModal('loader_inside_modal_confirm_assignation');
    this.ms.assignDriver(data).subscribe(
      (data: any) => {
        if (!data.wasSuccessful && data?.statusCode) {
          this.hideLoaderModal('loader_inside_modal_confirm_assignation');
          this.modalRef?.hide();
          this.hs.showErrorCode(data.statusCode);
        } else {
          this.hideLoaderModal('loader_inside_modal_confirm_assignation');
          this.modalRef?.hide();
          this.reloadData();
          this.show_left_div = true;
          let name = this.active_driver.general_info
            ? this.active_driver.general_info.fullName
            : this.active_driver.driverName;
          this.showDepositAlert(
            'El servicio de ' +
              this.active_detail_service.mainProductName +
              '(' +
              this.active_detail_service.orderHash +
              ') se ha asignado a ' +
              name,
            'Se ha asignado el servicio de forma satisfactoria'
          );
        }
      },
      (error) => {
        this.hideLoaderModal('loader_inside_modal_confirm_assignation');
        if (error.status === 500) {
          this.alerts
            .open('Problema en el servidor', {
              label: 'Error 500',
              status: 'error',
              autoClose: false,
            })
            .subscribe();
        } else {
          this.alerts
            .open(error, {
              label: 'Otro error',
              status: 'error',
              autoClose: false,
            })
            .subscribe();
        }
      }
    );
  }

  confirmDesAssign() {
    let data = {
      driverId: '00000000-0000-0000-0000-000000000000',
      orderHash: this.active_detail_service.orderHash,
      isSweeperAssignation: false,
      nodeId: this.active_detail_service.nodeId,
    };
    this.showLoaderModal('loader_inside_modal_confirm_desassignation');
    this.ms.assignDriver(data).subscribe(
      (data: any) => {
        if (!data.wasSuccessful && data?.statusCode) {
          this.hideLoaderModal('loader_inside_modal_confirm_desassignation');
          this.modalRef?.hide();
          this.hs.showErrorCode(data.statusCode);
        } else {
          this.hideLoaderModal('loader_inside_modal_confirm_desassignation');
          this.modalRef?.hide();
          this.reloadData();
          this.show_left_div = true;
          this.showDepositAlert(
            'El servicio de ' +
              this.active_detail_service.mainProductName +
              '(' +
              this.active_detail_service.orderHash +
              ') se ha desasignado a ' +
              this.active_driver.general_info?.fullName,
            'Se ha desasignado el servicio de forma satisfactoria'
          );
        }
      },
      (error) => {
        this.hideLoaderModal('loader_inside_modal_confirm_desassignation');
        if (error.status === 500) {
          this.alerts
            .open('Problema en el servidor', {
              label: 'Error 500',
              status: 'error',
              autoClose: false,
            })
            .subscribe();
        } else {
          this.alerts
            .open(error, {
              label: 'Otro error',
              status: 'error',
              autoClose: false,
            })
            .subscribe();
        }
      }
    );
  }

  checkAssignedServices(driver: any): boolean {
    return driver.assignedServices?.some(
      (service: any) =>
        service.orderStatus !== 'FINISHED' &&
        service.orderStatus !== 'CANCELLED_BY_CAFLER' &&
        service.orderStatus !== 'CANCELLED_BY_CLIENT' &&
        service.orderStatus !== 'FAILED'
    );
  }

  reloadData() {
    var date_send = Math.floor(new Date(this.dateFilter).getTime() / 1000);
    const serviceData = {
      date: { seconds: date_send },
      zoneId: this.filterForm.value.zoneFilter,
    };
    this.ngZone.run(() => {
      this.elements_services = [];
      this.filtered_services = [];

      this.elements_drivers = [];
      this.filtered_drivers = [];

      this.drivers_for_service = [];
      this.active_desasign_driver = false;

      this.selectedItemFilter = 'services';
      this.clearAllMapElements();
      this.PointsMarkers = [];
    });

    this.showLoader();
    this.ms.getServices(serviceData).subscribe((services: any) => {
      services.forEach((obj: any, index: any) => {
        obj.unassignedServices.forEach((obj: any, index: any) => {
          let textDateStart = obj.pickupDate.time.split(':');
          obj.FormatedHour = textDateStart[0] + ':' + textDateStart[1];
          this.elements_services.push(obj);
        });

        obj.activeDrivers.forEach((obj: any, index: any) => {
          this.elements_drivers.push(obj);
        });
      });

      this.elements_services.forEach((obj: any, index: any) => {
        let data = {
          type: 'pickup',
          obj: obj.pickupPoint,
          gi: obj,
        };
        this.PointsMarkers.push(data);

        let data2 = {
          type: 'dest',
          obj: obj.destinationPoint,
          gi: obj,
        };
        this.PointsMarkers.push(data2);
      });
      this.filtered_services = [...this.elements_services];

      const mergedDrivers = this.elements_drivers.reduce(
        (acc: any, current: any) => {
          const existingDriver = acc.find(
            (driver: any) => driver.driverId === current.driverId
          );
          if (existingDriver) {
            existingDriver.assignedServices.push(...current.assignedServices);
          } else {
            acc.push(current);
          }
          return acc;
        },
        []
      );
      let driverPromises = mergedDrivers.map((obj: any, index: any) => {
        return this.ms
          .getDriver(obj.driverId)
          .toPromise()
          .then((data: any) => {
            const general_info = data?.drivers?.[0];
            if (!general_info) return;
            obj.general_info = general_info;

            // No mostramos en el mapa a los conductores inactivos.
            if (!general_info.isActive) return;

            if (obj.lastLocation) {
              let data = {
                type: 'driver',
                obj: obj.lastLocation,
                gi: general_info,
              };
              this.PointsMarkers.push(data);
            }

            if (obj.assignedServices.length > 0) {
              if (general_info && general_info.isActive) {
                obj.assignedServices
                  .filter((x: any) => this.isServiceActiveStatus(x))
                  .forEach((service: any) => {
                    if (service.pickupPoint) {
                      let data = {
                        type: 'pickup',
                        obj: service.pickupPoint,
                        gi: service,
                      };
                      this.PointsMarkers.push(data);
                    }
                    if (service.destinationPoint) {
                      let data2 = {
                        type: 'dest',
                        obj: service.destinationPoint,
                        gi: service,
                      };
                      this.PointsMarkers.push(data2);
                    }
                  });

                obj.assignedServices = obj.assignedServices
                  .filter((x: any) => this.isServiceActiveStatus(x))
                  .sort((a: any, b: any) => {
                    let textDateStartA = a.pickupDate.time.split(':');
                    let textDateStartB = b.pickupDate.time.split(':');

                    const hourA = textDateStartA[0] + ':' + textDateStartA[1];
                    const hourB = textDateStartB[0] + ':' + textDateStartB[1];

                    if (hourA < hourB) return -1;
                    if (hourA > hourB) return 1;
                    return 0;
                  }
                );
              }
            }
          });
      });

      Promise.allSettled(driverPromises)
        .then((results) => {
          const rejectedCount = results.filter(
            (result) => result.status === 'rejected'
          ).length;
          if (rejectedCount > 0) {
            console.warn(
              `Fallaron ${rejectedCount} llamadas de detalle de conductor en reloadData, se continúa con los datos disponibles.`
            );
          }

          this.filtered_drivers = [
            ...this.elements_drivers.filter(
              (x: any) =>
                x.general_info !== undefined && x.general_info.isActive === true
            ),
          ];

          this.drawMapPoints();
        })
        .finally(() => {
          this.hideLoader();
        });
    });

    setTimeout(() => {
      const closeDiv = document.querySelector('.t-close');
      if (closeDiv) {
        (closeDiv as HTMLElement).click();
      }
    }, 5000);
  }

  directionsRenderers: google.maps.DirectionsRenderer[] = [];
  type_driver_start: any = 'service';
  icon_driver_start: any = '';

  drawRoutesDriver(driver: any) {
    const directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
    });
    let waypts: google.maps.DirectionsWaypoint[] = [];
    let start = {};
    let end = {};

    this.directionsRenderer.setMap(this.map);

    const registros = driver.assignedServices.filter(
      (x: any) => this.isServiceActiveStatus(x)
    );
    if (registros.length > 0) {
      let startPoint = {
        lat: registros[0].pickupPoint.Latitude,
        lng: registros[0].pickupPoint.Longitude,
      };
      if (driver.lastLocation) {
        startPoint = {
          lat: driver.lastLocation.Latitude,
          lng: driver.lastLocation.Longitude,
        };

        waypts.push({
          location: new google.maps.LatLng(
            registros[0].pickupPoint.Latitude,
            registros[0].pickupPoint.Longitude
          ),
          stopover: true,
        });

        this.type_driver_start = 'driver';
        this.icon_driver_start = this.getInitial(driver.general_info.fullName);
      }
      const endPoint = {
        lat: registros[registros.length - 1].destinationPoint.Latitude,
        lng: registros[registros.length - 1].destinationPoint.Longitude,
      };

      for (let i = 0; i < registros.length; i++) {
        if (i < registros.length - 1) {
          waypts.push({
            location: new google.maps.LatLng(
              registros[i].destinationPoint.Latitude,
              registros[i].destinationPoint.Longitude
            ),
            stopover: true,
          });
        }

        if (registros[i].nodes) {
          registros[i].nodes.forEach((obj: any, index: any) => {
            if (
              obj.nodeVerticalType != 'INTERNAL_RETURN' &&
              obj.nodeVerticalType != 'INTERNAL_PICKUP'
            ) {
              if (obj.location) {
                if (obj.location.Latitude != obj.location.Longitude) {
                  let wlo = new google.maps.LatLng(
                    obj.location.Latitude,
                    obj.location.Longitude
                  );
                  waypts.push({
                    location: wlo,
                    stopover: true,
                  });
                }
              }
            }
          });
        }
      }

      directionsService.route(
        {
          origin: startPoint,
          destination: endPoint,
          waypoints: waypts,
          travelMode: google.maps.TravelMode.DRIVING,
          optimizeWaypoints: true,
        },
        (result: any, status: any) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.directionsRenderer.setDirections(result);
            const route = result.routes[0];
            const legs = route.legs;
            this.addCustomMarkers(result);
          }
        }
      );
    }
  }

  addCustomMarkers(response: any): void {
    const route = response.routes[0];
    const legs = route.legs;

    for (let i = 0; i < legs.length; i++) {
      const leg = legs[i];

      if (leg.via_waypoints && leg.via_waypoints.length > 0) {
        leg.via_waypoints.forEach((waypoint: any, index: any) => {
          let cc = new google.maps.Marker({
            position: waypoint, // Cada via_waypoint
            map: this.map,
            icon: {
              url: 'assets/img/icon_service3.png', // Ruta a tu ícono personalizado
              scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
            },
            title: '',
          });

          this.customMarkers.push(cc);
        });
      }
      if (i === 0) {
        if (this.type_driver_start == 'service') {
          let pi = new google.maps.Marker({
            position: leg.start_location, // Punto de inicio del primer leg
            map: this.map,
            icon: {
              url: 'assets/img/icon_service.png', // Ruta a tu ícono personalizado
              scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
            },
            title: leg.start_address,
          });
          this.customMarkers.push(pi);
        } else {
          let pi = new google.maps.Marker({
            position: leg.start_location, // Punto de inicio del primer leg
            map: this.map,
            icon: {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
                this.icon_driver_start
              )}`,
              scaledSize: new google.maps.Size(30, 30),
            },
            title: '',
          });
          this.customMarkers.push(pi);
        }
      }

      // Marcar el punto final del leg
      if (i === legs.length - 1) {
        let pf = new google.maps.Marker({
          position: leg.end_location, // Punto final del último leg
          map: this.map,
          icon: {
            url: 'assets/img/icon_service2.png', // Ruta a tu ícono personalizado
            scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
          },
          title: leg.end_address,
        });
        this.customMarkers.push(pf);
      } else {
        let pw = new google.maps.Marker({
          position: leg.end_location,
          map: this.map,
          icon: {
            url: 'assets/img/icon_service3.png', // Ruta a tu ícono personalizado
            scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
          },
          title: leg.end_address,
        });
        this.customMarkers.push(pw);
      }
    }

    let cmarkers = this.customMarkers;
    let map = this.map;
    const markerClusterNew = new MarkerClusterer(map, cmarkers, {
      styles: [
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-1',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-2',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-3',
        },
      ],
      clusterClass: 'custom-clustericon',
      zoomOnClick: false,
    });
    this.markerCluster = markerClusterNew;
    let infoWindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, 0),
    });

    google.maps.event.addListener(markerClusterNew, 'click', (cluster) => {
      const markers = cluster.getMarkers();
      let content =
        '\
                <table class="table table-bordered" style="width:700px">\
                    <thead>\
                    </thead>\
                    <tbody>';
      markers.forEach((marker: any) => {
        let icon = marker.getIcon();
        if (marker.getTitle() != '') {
          content += `<tr><td><img src="${
            icon.url
          }" width="30" /> ${marker.getTitle()}</td><tr>`;
        }
      });
      content += '</tbody></table>';

      infoWindow.setContent(content);
      infoWindow.setPosition(cluster.getCenter());
      infoWindow.open(map);
    });
  }

  setShowServices(driver: any) {
    if (this.show_assign_services == driver.driverId) {
      this.show_assign_services = 0;
    } else {
      if (
        driver.assignedServices &&
        driver.assignedServices.filter((x: any) => this.isServiceActiveStatus(x)).length > 0
      ) {
        this.show_assign_services = driver.driverId;
      }
    }
  }

  showDepositAlert(title: any, msj: any): void {
    this.alerts
      .open(msj, {
        label: title,
        status: 'success',
        autoClose: false,
      })
      .subscribe();
  }

  showLeftDiv() {
    this.expandDivLeft = true;
    this.leftDivStyles.x = 440;
  }

  changeSelectedItemFilter(item: any) {
    this.selectedItemFilter = item;
    if (item == 'services') {
      this.ngZone.run(() => {
        this.show_assign_services = 0;
        this.clearAllMapElements();
        this.drawMapPoints();
      });
    }
  }

  zoomInMap() {
    const currentZoom = this.map.getZoom();
    this.map.setZoom(currentZoom + 1);
  }

  zoomOutMap() {
    const currentZoom = this.map.getZoom();
    if (currentZoom >= 6) {
      this.map.setZoom(currentZoom - 1);
    }
  }

  geoLocateUser(): void {
    if (!navigator.geolocation) {
      this.showGeoError(this.translate.instant('GEOLOCATION.BROWSER_NOT_SUPPORTED'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (this.userLocationMarker) {
          this.userLocationMarker.setMap(null);
        }

        const userLocation = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        this.map.setCenter(userLocation);
        this.map.setZoom(17);

        this.userLocationMarker = new google.maps.Marker({
          position: userLocation,
          map: this.map,
          title: 'Mi ubicación',
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: '#4285F4',
            fillOpacity: 1,
            strokeColor: '#fff',
            strokeWeight: 3,
          },
        });
      },
      (error) => {
        const errorMsg = this.getGeoErrorMessage(error);
        this.showGeoError(errorMsg);
      }
    );
  }

  private getGeoErrorMessage(error: GeolocationPositionError): string {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return this.translate.instant('GEOLOCATION.PERMISSION_DENIED');
      case error.POSITION_UNAVAILABLE:
        return this.translate.instant('GEOLOCATION.POSITION_UNAVAILABLE');
      case error.TIMEOUT:
        return this.translate.instant('GEOLOCATION.TIMEOUT');
      default:
        return this.translate.instant('GEOLOCATION.ERROR');
    }
  }

  private showGeoError(message: string): void {
    this.alerts
      .open(message, {
        label: this.translate.instant('GEOLOCATION.TITLE'),
        status: 'error',
        autoClose: true,
      })
      .subscribe();
  }

  formatTimeUnit(unit: any) {
    return unit < 10 ? `0${unit}` : unit;
  }

  getDateHour(seconds: any, zoneId: any) {
    const date = new Date(seconds * 1000);

    const hour = this.formatTimeUnit(date.getHours());
    const min = this.formatTimeUnit(date.getMinutes());

    const zone = this.zones.find(
      (zone: any) => zone.zoneId === this.filterForm.value.zoneFilter
    );

    const dateInClientZone = moment.unix(seconds).tz(zone.timeZone);
    const IsCh = dateInClientZone.isDST();
    if (IsCh) {
      dateInClientZone.subtract(1, 'hour');
    }

    return dateInClientZone.format('HH:mm');
  }

  clearMarkers(): void {
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
      this.markerCluster = null;
    }
    for (let marker of this.PointsMarkers) {
      marker.marker.setMap(null); // Borra el marcador del mapa
    }
    for (let markerd of this.drivers_markers) {
      markerd.setMap(null);
    }
  }

  getRoleInfo(roleName: string) {
    const selecteRole = this.rolesGeneral.find(
      (rol: any) => rol.role === roleName
    );
    return selecteRole?.name;
  }

  private saveFilters(): void {
    const filters = {
      zoneFilter: this.filterForm.get('zoneFilter')?.value,
      dateFilter: this.filterForm.get('dateFilter')?.value,
      mapfilter: this.filterForm.get('mapfilter')?.value,
    };
    localStorage.setItem(this.filtersStorageKey, JSON.stringify(filters));
  }

  private restoreFilters(): void {
    const savedFilters = localStorage.getItem(this.filtersStorageKey);
    if (!savedFilters) return;
    try {
      const filters = JSON.parse(savedFilters);
      // emitEvent: false para evitar que valueChanges dispare loadData durante la restauración.
      // Se llama loadData() explícitamente al terminar si hay filtros completos.
      if (filters.zoneFilter) {
        this.filterForm.get('zoneFilter')?.setValue(filters.zoneFilter, { emitEvent: false });
      }
      if (filters.dateFilter) {
        this.filterForm.get('dateFilter')?.setValue(filters.dateFilter, { emitEvent: false });
      }
      if (filters.mapfilter) {
        this.filterForm.get('mapfilter')?.setValue(filters.mapfilter, { emitEvent: false });
      }
      if (filters.zoneFilter && filters.dateFilter) {
        this.loadData();
      }
    } catch (error) {
      console.error('Error restoring filters:', error);
    }
  }

  private clearFilters(): void {
    localStorage.removeItem(this.filtersStorageKey);
  }

  calculateJourneyTime(distance: any) {
    let speed = 70;
    let journeyTime = '';
    if (distance > 0 && speed > 0) {
      const timeInHours = distance / speed;
      const hours = Math.floor(timeInHours);
      const minutes = Math.round((timeInHours - hours) * 60);

      journeyTime = `${hours}h ${minutes}m`;
    } else {
      journeyTime = 'La distancia y la velocidad deben ser mayores que 0';
    }

    return journeyTime;
  }
}
